import { render, staticRenderFns } from "./orderRoute2022.vue?vue&type=template&id=d98ed1aa&scoped=true&"
import script from "./orderRoute2022.vue?vue&type=script&lang=js&"
export * from "./orderRoute2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98ed1aa",
  null
  
)

export default component.exports